import { computed } from 'vue'

const ordinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd']
  const v = n % 100
  return n + (s[(v - 20) % 10] ?? s[v] ?? s[0])
}

const countTradingDays = (startDate, daySpan) => {
  const cursor = new Date(startDate)
  let count = 0
  for (let i = 0; i < daySpan; i += 1) {
    const day = cursor.getDay()
    if (day !== 0 && day !== 6) count += 1
    cursor.setDate(cursor.getDate() + 1)
  }
  return count
}

export function useCompetitionDates(competition) {
  const currentCompetitionDay = computed(() =>
    Math.min(Math.max(1, competition.days_elapsed), competition.duration_days)
  )

  const tradingDates = computed(() => {
    const dates = []
    const targetDays = Math.max(2, competition.days_elapsed)
    const cursor = new Date(competition.start_date)
    while (dates.length < targetDays) {
      if (cursor.getDay() !== 0 && cursor.getDay() !== 6) dates.push(new Date(cursor))
      cursor.setDate(cursor.getDate() + 1)
    }
    return dates
  })

  const totalTradingDays = computed(() =>
    countTradingDays(competition.start_date, competition.duration_days)
  )

  const elapsedTradingDays = computed(() =>
    Math.min(totalTradingDays.value, tradingDates.value.length)
  )

  const tradingDaysRemaining = computed(() =>
    Math.max(0, totalTradingDays.value - elapsedTradingDays.value)
  )

  const lastTradingDay = computed(() => {
    const end = new Date(competition.start_date)
    end.setDate(end.getDate() + competition.duration_days - 1)
    while (end.getDay() === 0 || end.getDay() === 6) end.setDate(end.getDate() - 1)
    const weekday = end.toLocaleDateString('en-GB', { weekday: 'short' })
    const month = end.toLocaleDateString('en-GB', { month: 'short' })
    return `${weekday}, ${ordinal(end.getDate())} ${month}`
  })

  return {
    currentCompetitionDay,
    tradingDates,
    totalTradingDays,
    elapsedTradingDays,
    tradingDaysRemaining,
    lastTradingDay,
  }
}
